import * as yup from 'yup';

const prizeFormSchema = yup.object({
  prizes: yup.array(
    yup.lazy((activities) => {
      const length = Object.values(activities).filter((v) => !!v).length;

      if (length === 0) return yup.object();

      return yup.object({
        institution: yup.string().required('수여 기관을 입력해주세요.'),
        name: yup.string().required('수상명을 입력해주세요.'),
        date: yup.lazy((startDate) => {
          return startDate ? yup.date() : yup.string().required('일자를 입력해주세요.');
        }),
        description: yup.string(),
      });
    }),
  ),
});

export default prizeFormSchema;
